/**
 * AdventureTab — extracted from /app/frontend/src/pages/PalGame.jsx
 * as part of the per-tab split. Behaviour identical to the
 * pre-split monolith; only the file boundary changed.
 */
import { useEffect, useState, useMemo, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useToast } from "@/context/ToastContext";
import { PageHeader, Currency, Loader, RarityBadge } from "@/components/Atoms";
import { ChilletSkull } from "@/components/ChilletSkull";
import { ChilletCoinIcon } from "@/components/ChilletCoinIcon";
import { PalPortrait, ElementChip } from "@/components/PalAssets";
import { PayoutFlash } from "@/components/PayoutFlash";
import { AchievementUnlocked } from "@/components/AchievementUnlocked";
import { MasterTrainerCinematic } from "@/components/MasterTrainerCinematic";
import { useMasterTrainers } from "@/hooks/useMasterTrainers";
import {
  Swords, Sparkles, Zap, Compass, Trophy, Layers, Target, Castle,
  ArrowLeftRight, Map, Crosshair, Heart, ChevronLeft, BookOpen,
} from "lucide-react";
import { PalPicker, ActionWithPal, firePalgamePayout, firePalgameDefeat } from "./_shared";

export function AdventureTab() {
  return (
    <div className="space-y-5">
      {/* Hero banner — the explorer-with-Chillet artwork sets the "send
          your pal into the wilds" mood at the top of the tab. The image
          is shown in full (no crop) with a dark vignette around the
          sides so the square 1024×1024 art sits gracefully inside a
          widescreen card. Title + tagline sit ABOVE the art so they
          don't cover any of the painting. */}
      <div
        className="relative overflow-hidden rounded-lg border border-white/10 fade-up bg-black/60"
        aria-hidden="false"
        data-testid="adventure-banner"
      >
        <div className="px-4 sm:px-5 pt-4 pb-3">
          <h2 className="text-2xl sm:text-3xl glow-teal" style={{ fontFamily: "'Cinzel Decorative', serif" }}>
            Send your Pal into the wilds
          </h2>
          <p className="text-xs sm:text-sm text-[var(--bone)]/80 mt-1 max-w-xl">
            Adventures pay out coins and XP based on rarity. Higher-tier Pals
            return with more — and the rarer the find, the louder the reward.
          </p>
        </div>
        <img
          src="/assets/palgame/adventure_banner.png"
          alt="Explorer and her Chillet pal overlooking the wilds"
          className="block mx-auto max-h-[520px] w-auto"
          draggable="false"
        />
      </div>
      <ActionWithPal kind="adventure" label="Send on Adventure" testid="adventure" endpoint="/palgame/adventure" />
    </div>
  );
}
